import React from 'react';
// Modules
import { Box, Heading, VStack } from '@chakra-ui/react';

interface Props {
  title: string;
}

const PromotionListSectionContainer: React.FC<Props> = ({ children, title }) => (
  <VStack alignItems="stretch" spacing="4">
    <VStack alignItems="flex-start">
      <Heading as="h2" size="lg">
        {title}
      </Heading>
      <Box bgColor="primary.500" h="4px" w="64px" />
    </VStack>

    {children}
  </VStack>
);

export default PromotionListSectionContainer;
